import {
  GET_NOMINATION_DETAILS_FAILURE,
  GET_NOMINATION_DETAILS_REQUEST,
  GET_NOMINATION_DETAILS_RESET,
  GET_NOMINATION_DETAILS_SUCCESS,
} from "../../../../redux/types/awards"

const initialState = {
  loading: false,
  message: "",
  error: "",
  success: false,
}

const getNominationDetailsReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_NOMINATION_DETAILS_REQUEST:
      return {
        ...state,
        loading: true,
        message: "",
        error: "",
        success: false,
      }

    case GET_NOMINATION_DETAILS_SUCCESS:
      return {
        ...state,
        loading: false,
        message: action.payload.message,
        error: "",
        success: true,
      }

    case GET_NOMINATION_DETAILS_FAILURE:
      return {
        ...state,
        loading: false,
        message: "",
        error: action.payload.error,
        success: false,
      }

    case GET_NOMINATION_DETAILS_RESET:
      return {
        ...initialState,
      }

    default:
      return state
  }
}

export default getNominationDetailsReducer
